import { ViewModel } from './model';
import html from './template.html';
import './style.less';

ko.components.register('radio-group', {
  viewModel: {
    createViewModel: (params, componentInfo) => {
      let element = componentInfo.element;
      element.classList.add('f-radio-group');

      return new ViewModel(params, element);
    },
  },
  template: html,
});
